// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input_Input__3r5Ke","Label":"Input_Label__1qyHr","InputElement":"Input_InputElement__2m88K","focus":"Input_focus__1BgVv","Invalid":"Input_Invalid__16Mis"};